import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  DetectionsByDetectionGroupsPerEntity,
  QueryGetTopDetectionsByDetectionGroupsPerEntityArgs,
} from '@investigator/shared/generated/graphql';

export interface GetTopDetectionsByDetectionGroupsPerEntity {
  getTopDetectionsByDetectionGroupsPerEntity: DetectionsByDetectionGroupsPerEntity;
}

export const GET_DETECTIONS_BY_DETECTION_GROUPS_PER_ENTITY = gql`
  query getTopDetectionsByDetectionGroupsPerEntity(
    $start: Float!
    $end: Float!
    $tenant: String
    $size: Int
    $sort: [SortParameterInput]
    $tenant_entity: String!
    $group_by: DetectionGroups!
  ) {
    getTopDetectionsByDetectionGroupsPerEntity(
      tenant: $tenant
      start: $start
      end: $end
      size: $size
      sort: $sort
      tenant_entity: $tenant_entity
      group_by: $group_by
    ) {
      group_by
      tenant_entity
      tenant
      sort {
        sort_by
        sort_dir
      }
      data {
        group_key
        detections_count
        detections {
          detection_id
          rank {
            severity
            is_custom_severity
          }
          latest_start_timestamp
          mitre_tactics
          mitre_techniques
          alert_entity {
            entity_id
            entity_name
            entity_type
            entity_category
          }
          alert_info {
            alert_name
            alert_type
          }
        }
      }
      __typename
    }
  }
`;

export const useGetTopDetectionsByDetectionGroupsPerEntity = (
  options: QueryHookOptions<
    GetTopDetectionsByDetectionGroupsPerEntity,
    QueryGetTopDetectionsByDetectionGroupsPerEntityArgs
  >,
) =>
  useQuery<
    GetTopDetectionsByDetectionGroupsPerEntity,
    QueryGetTopDetectionsByDetectionGroupsPerEntityArgs
  >(GET_DETECTIONS_BY_DETECTION_GROUPS_PER_ENTITY, options);
